/**
 * Payment / reprice SSOT: rate must be USD→ILS (ILS per 1 USD).
 * adminLogic.getRate("USD","ILS") returns ILS/USD (~0.336); getRate("ILS","USD") returns ~2.97.
 */

export function normalizePaymentUsdToIlsRate(rate) {
  const r = Number(rate);
  if (!Number.isFinite(r) || r <= 0) return null;

  if (r >= 2) return r;

  if (r > 0 && r < 1) {
    const inverted = 1 / r;
    if (inverted >= 2 && inverted <= 8) return inverted;
  }

  return r;
}

/** Convert USD amount to ILS using USD→ILS rate only (never invert). */
export function convertUsdToIlsForPayment(usdAmount, usdToIlsRate) {
  const usd = Number(usdAmount);
  const rate = normalizePaymentUsdToIlsRate(usdToIlsRate);
  if (!Number.isFinite(usd) || usd <= 0 || rate == null) return null;
  return Number((usd * rate).toFixed(2));
}
